export const useGeolocation = () => {
    const locateUser = (onSuccess: (position: GeolocationCoordinates) => void, onError: (error: GeolocationPositionError) => void) => {
        const geolocation = navigator?.geolocation;
        if (geolocation) {
            geolocation.getCurrentPosition(
                (position) => {
                    onSuccess(position.coords);
                },
                (error) => {
                    onError(error);
                },
                {
                    enableHighAccuracy: true
                }
            );
        }
    };

    return {
        locateUser
    };
};
export const useGeolocation = () => {
    const locateUser = (onSuccess: (position: GeolocationCoordinates) => void, onError: (error: GeolocationPositionError) => void) => {
        const geolocation = navigator?.geolocation;
        if (geolocation) {
            geolocation.getCurrentPosition(
                (position) => {
                    onSuccess(position.coords);
                },
                (error) => {
                    onError(error);
                },
                {
                    enableHighAccuracy: true
                }
            );
        }
    };

    return {
        locateUser
    };
};
